import { render } from "./PaqueteExamen.vue?vue&type=template&id=f7390dc2&scoped=true"
import script from "./PaqueteExamen.vue?vue&type=script&lang=js"
export * from "./PaqueteExamen.vue?vue&type=script&lang=js"

import "@/assets/css/listaRegistros.css?vue&type=style&index=0&id=f7390dc2&scoped=true&lang=css"
import "./PaqueteExamen.vue?vue&type=style&index=1&id=f7390dc2&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f7390dc2"]])

export default __exports__